import { useQuery } from '@tanstack/react-query'
import { fetchLatestIntel } from '../api/intelClient'
import type { IntelReport } from '../model/contracts'

export function useLatestIntel(topicId: string) {
  return useQuery<IntelReport, Error>({
    queryKey: ['intel', topicId],
    queryFn: ({ signal }) => fetchLatestIntel(topicId, signal),
    enabled: !!topicId,
  })
}
